import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as MobilePhone } from '../../assets/images/svg/mobile-phone.svg';
import themeColors from '../../assets/styles/themeColors';

const MobilePhoneIconStyled = styled(MobilePhone)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  color: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const MobilePhoneIcon = (props) => <MobilePhoneIconStyled {...props} />;

MobilePhoneIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

MobilePhoneIcon.defaultProps = {
  w: '25px',
  h: '25px',
};

export default MobilePhoneIcon;
